module.exports = __webpack_public_path__ + "img/CCC-logo.f0a0e128.png";